/*
SaiKrishna 10/06/2022 3075154998 Removed unnecessary console.log statements
Suresh Peddavoora 10/26/2022 3075154998  Added Class Name for Text Fields and Buttons
Akhila  10/28/2022 3075154998 data manager ux changes
Guru Prasad  10/29/2022 3075154998 data manager Card styles UI changes
Suresh Peddavoora 10/31/2022 3075154998  Added Grid spacings for Text Fields
Raghu 11/03/2022 3075154998  Responsive Alignment Fixes
Lalitha  11/9/2022  3075154998 Rename Button Cancel to Reset
*/
import React, {useEffect, useState, useContext} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {Button, Grid, TextField, Typography, FormHelperText} from '@material-ui/core';
import DialogBox from '../../../../../components/DialogBox';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import AddIcon from '@material-ui/icons/Add';
import AddDMRecordGroupTable from './AddDMRecordGroupTable';
import {useDispatch, useSelector} from 'react-redux';
import AddForm from './AddForm';
import {RECORD_TYPE} from '../../../../../constants/Lookup';
import {getOptions} from '../../../../../util/GetDropDownOptions';
import {getDropDownData} from '../../../../../redux/reducers/EnableFramework/Filter';
import {fetchFilter} from '../../../../../redux/reducers/DMRecord';
import {ResetMessage as resetMessage, ResetStatus as resetStatus} from '../../../../../redux/reducers/DataManagerFilter';
import {ArrowBack} from '@material-ui/icons';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';

const AddDMRecordGroupForm = ({
  setValue,
  filterCode,
  setFilterCode,
  setFilterCodeName,
  filterCodeName,
  isCopyRowData,
  setUsageState,
}) => {
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  const {dropDownData} = useSelector(({filter}) => filter);
  const {
    filterDataStatus,
    successMsg,
    //  addFiltersStatus,
    isLoading,
    recordData,
    // userMetrix,
  } = useSelector(({dmRecord}) => dmRecord);
  const initialValues = {
    description: recordData?.description ? recordData?.description : '',
    dmCode: recordData?.dmCode ? recordData?.dmCode : '',
    filterGroupCode: recordData?.filterGroupCode ? recordData?.filterGroupCode : '',
    // matchingLogic: "logic",
    recordGroupCode: 'SDR23',
    recordGroupId: 10,
    // recordIdEnd: 10,
    recordIdLength: recordData?.recordGroupId ? recordData?.recordGroupId : '',
    recordIdStart: recordData?.recordIdStart ? recordData?.recordIdStart : '',
    recordType: recordData?.recordType ? recordData?.recordType : '',
  };

  const [open, setOpen] = useState('');
  const [tableData, setTableData] = useState('');
  useEffect(() => {
    if (Object.keys(recordData)?.length > 0) {
      const data = recordData?.recordGroupDetailRequest?.length > 0 ? [...recordData?.recordGroupDetailRequest] : [];
      const newData = data?.map((i) => {
        const conditionList = {
          ...i,
          detailId: i?.detailId ? i?.detailId : 0,
          sequenceNumber: i?.sequenceNumber ? i?.sequenceNumber : '',
          // dmCode: i?.dmCode ? i?.dmCode : "",
          textValue: i?.textValue ? i?.textValue : '',
          length: i?.recordLength ? i?.recordLength : '',
          srt: i?.srt ? i?.srt : '',
          recordFormat: i?.recordFormat ? i?.recordFormat : '',
        };

        return conditionList;
      });
      setTableData(newData);
    }
    // if (Object.keys(filterData).length > 0) {
    //   const data = [...filterData?.filterActions];
    //   const newActionData = data.map((i) => {
    //     return {
    //       ...i,
    //       description: i?.description ? i.description : "",
    //       conditionOperator: i?.conditionOperator ? i.conditionOperator : "",
    //       fieldFormat: i?.fieldFormat ? i.fieldFormat : "",
    //       actionId: i?.actionId ? i?.actionId : 0,
    //       name: i?.fieldCode ? i.fieldCode : "",
    //       returnValueType: i?.returnType ? i.returnType : "",
    //       sourceField: i?.sourceField ? i.sourceField : "",
    //       toField: i?.toField ? i.toField : "",
    //       type: i?.type ? i.type : "",
    //       sequenceNo: i?.sequenceNo ? Number(i?.sequenceNo) : "",

    //       disposition: i?.disposition ? i.disposition : "",
    //     };
    //   });
    //   setActionData(newActionData);
    // }
  }, [recordData]);
  useEffect(() => {
    filterCode && dispatch(fetchFilter(filterCode?.filterCode));
  }, [filterCode]);
  useEffect(() => {
    dispatch(getDropDownData());
  }, []);
  useEffect(() => {
    if (filterDataStatus === 200) {
      setTimeout(() => {
        setValue(0);
        dispatch(resetStatus());
        dispatch(resetMessage());
      }, 2000);
    }
  }, [filterDataStatus]);

  const schema = Yup.object().shape({
    dmCode: Yup.string()
      .required('code is required')
      .matches(/^[a-zA-Z0-9]+$/, 'White space and special character are not allowed'),
    description: Yup.string().required('Description is required'),
  });

  const handleSubmit = () => {};

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <div className="button-table-spacing-mb justify-content-start">
        <Button
          variant="outlined"
          type="button"
          disabled={isLoading || successMsg}
          className={`search-btn mx-1 ${classes.buttonRoot}`}
          onClick={() => {
            setValue(0);
          }}
        >
          <ArrowBack className="mr-2" />
                    Search Record Group
        </Button>
      </div>
      <div>
        <Formik
          onSubmit={(values, {validate}) => {
            handleSubmit(values);
            validate(values);
          }}
          initialValues={initialValues}
          validationSchema={schema}
          validateOnChange={true}
          validateOnBlur={false}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleSubmit,
              handleReset,
              handleBlur,
              setFieldValue,
              touched,
              errors,
            } = props;
            return (
              <div className={`mb-0`}>
                <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                  <div className="global-field-textfields">
                    <Grid container spacing={2}>
                      <Grid item xs={4} lg={3} md={4} sm={6} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder="Enter Code"
                          label="Code"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="dmCode"
                          value={values?.dmCode?.toUpperCase()}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          required
                          touched={touched.dmCode}
                          error={Boolean(touched.dmCode && errors.dmCode)}
                        />
                        <FormHelperText style={{color: 'red'}}>
                          {touched.dmCode && errors.dmCode}
                        </FormHelperText>
                      </Grid>
                      <Grid item xs={4} lg={3} md={4} sm={6} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Description`}
                          label="Description"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="description"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          required
                          touched={touched.description}
                          error={Boolean(touched.description && errors.description)}
                        />
                        <FormHelperText style={{color: 'red'}}>
                          {touched.description && errors.description}
                        </FormHelperText>
                      </Grid>
                      <Grid item xs={4} lg={3} md={4} sm={6} className="form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="recordType"
                          id="recordType"
                          size="small"
                          value={values.recordType}
                          options={getOptions(RECORD_TYPE, dropDownData)}
                          getOptionDisabled={(option) => option.valueCode === null}
                          getOptionLabel={(option) => {
                            return option && option.valueCode && option.value ?
                              option.valueCode + ' - ' + option.value :
                              option.value === null ?
                                option.valueCode :
                                option.value ?
                                  option.value :
                                  '';
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('recordType', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName} ${classes.selectLabel}`}
                                {...params}
                                error={touched.recordType && errors.recordType}
                                variant="outlined"
                                margin="dense"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                label="Record Type"
                                placeholder="Select Record Type"
                              />
                            </div>
                          )}
                        />
                      </Grid>
                      <Grid item xs={3} md={4} sm={6} lg={3} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          name="recordIdStart"
                          placeholder={`Enter Record ID Start`}
                          label="Record Id Start"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={values.recordIdStart}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={3} md={4} sm={6} lg={3} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          name="recordIdLength"
                          placeholder={`Enter Record Id Length`}
                          label="Record Id Length"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={values.recordIdLength}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                    <Grid>
                      <div>
                        <Grid item className={`border-rounded mb-4 px-2 `}>
                          <div className="table-header table-card-header">
                            <Typography variant="h3">Details: </Typography>
                            <Button
                              variant="outlined"
                              className={`search-btn ${classes.buttonRoot}`}
                              onClick={() => {
                                setOpen(true);
                              }}
                            >
                              <AddIcon />
                            Add
                            </Button>
                          </div>
                          <AddDMRecordGroupTable tableData={tableData} />
                        </Grid>
                      </div>
                    </Grid>
                  </div>
                  <div className="button-spacing-mb">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`reset-btn mx-1 ${classes.buttonRoot}`}
                      onClick={() => {}}
                    >
                    Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`mx-1 search-btn ${classes.buttonRoot}`}
                    >
                    Save
                    </Button>
                  </div>
                </form>
              </div>
            );
          }}
        </Formik>
        <DialogBox open={open} dialogClose={handleClose} title={'Add'} maxWidth="md">
          <AddForm tableData={tableData} />
        </DialogBox>
      </div>
    </div>
  );
};

export default AddDMRecordGroupForm;
